export default "__VITE_ASSET__BSbDAB1z__"